"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description Конвертирует миллисекунды в секунды.
 */
function toSeconds(milliseconds) {
    return Math.round((milliseconds * 100) / 1000) / 100;
}
exports.toSeconds = toSeconds;
//# sourceMappingURL=toSeconds.js.map